import React from 'react';
import Header from '../../Components/Header';
import InsuranceSearch from './InsuranceSearch';

const Insurance = () => (
   <>
  <Header></Header>
   <section className='Insurance_top_banner'>
      <InsuranceSearch />
    </section>
    <section class="footer_top"> 
		<div class="container">
		<div class="_toprflcont mb-8">
			<div class="_hdrtxt">Quick Links </div>
		</div>
     <div class="col-md-12">
        <div class="d-flex-bus">
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Domestic.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Domestic</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/International.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>International</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Annual.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Annual</h5>
                </a>
            </div>
           
           
           
        </div>
     </div>
           
            
        </div>    
    </section>
  </>
   
);

export default Insurance;
